import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Commission = {
  commission_id?: number; // 수수료 idx
  commission_rate?: number; // 수수료
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Commission
   * --
   */
  getCommissions: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_COMMISSION, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Commission
   * --
   */
  getCommission: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_COMMISSION, {
        commission_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Commission
   * --
   */
  createCommission: async (body: Commission) => {
    try {
      const res = await $http.post(APIConstant.CREATE_COMMISSION, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Commission
   * --
   */
  updateCommission: async (body: Commission) => {
    try {
      const { commission_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_COMMISSION, {
        commission_id: commission_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Commission
   * --
   */
  deleteCommission: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_COMMISSION, {
        commission_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
